export const FIELD_TYPES = [
    'text',
    'longText',
    'number',
    'checkbox',
    'date',
    'singleSelect',
    'multipleSelect',
    'email',
    'url',
    'phone',
    'createdTime',
    'lastModifiedTime',
    'createdBy',
    'lastModifiedBy',
    'recordId',
    'link',
    'lineItems',
    'lookup',
    'rollup',
    'count',
    'formula',
    'currency',
    'percent',
    'duration',
    'rating',
    'user',
    'autoNumber',
    'attachment',
    'dateRange',
    'json',
    'location',
    'signature',
    'button',
    'barcode',
    'time',
    'multiCurrency',
    'changeLog',
];
//# sourceMappingURL=field-types.js.map